import { render, staticRenderFns } from "./player-profile-form.vue?vue&type=template&id=5b448ea0&"
import script from "./player-profile-form.vue?vue&type=script&lang=js&"
export * from "./player-profile-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports